
import StandardHero from '~/components/StandardHero.vue'
import ProductIntro from '~/components/products/ProductIntro.vue'
import ProductSellingPoints from '~/components/products/ProductSellingPoints.vue'
import Benefits from '~/components/Benefits.vue'
/* import RelatedCasesSlider from '~/components/RelatedCasesSlider.vue' */
import ProductRelatedApps from '~/components/products/ProductRelatedApps.vue'
import Partnership from '~/components/Partnership.vue'
import ContactUs from '~/components/ContactUs.vue'

export default {
  head() {
    let headerContent = { script: [] }
    if (this.meta_fields) {
      this.setMetaData(this.meta_fields)
      headerContent.title = this.MixinMageTitle
      headerContent.meta = this.MixinMetaData
    }
    return headerContent
  },
  asyncData({ store, app, params, error }) {
    // Load the JSON from the API
    return app.$storyapi
      .get(
        `cdn/stories/${store.state.language}/products-tools/google-marketing-platform/${params.slug}`,
        {
          version: store.state.version,
          resolve_relations: 'component_related_cases_slide.cases'
        }
      )
      .then((res) => {
        return {
          header: res.data.story.content.head
            ? res.data.story.content.head
            : null,
          benefits: res.data.story.content.benefits
            ? res.data.story.content.benefits
            : null,
          wavesColor: res.data.story.content.color_select_waves
            ? res.data.story.content.color_select_waves
            : null,
          primaryColor: res.data.story.content.color_select_primary
            ? res.data.story.content.color_select_primary
            : null,
          secondaryColor: res.data.story.content.color_select_secondary
            ? res.data.story.content.color_select_secondary
            : null,
          sellingPoints: res.data.story.content.selling_points
            ? res.data.story.content.selling_points
            : null,
          contact: res.data.story.content.contact
            ? res.data.story.content.contact
            : null,
          connectedTools: res.data.story.content.connected_tools
            ? res.data.story.content.connected_tools
            : null,
          toolIntroduction: res.data.story.content.tool_introduction
            ? res.data.story.content.tool_introduction
            : null,
          // relatedCases: null
          relatedCases: res.data.story.content.related_cases
            ? res.data.story.content.related_cases
            : null,
          meta_fields:
            res.data.story.content.meta_fields !== undefined
              ? res.data.story.content.meta_fields
              : null
        }
      })
      .catch((res) => {
        if (!res.response) {
          console.error(res)
          error({
            statusCode: 404,
            message: 'Failed to receive content from Storyblok API'
          })
        } else {
          console.error(res.response.data)
          error({
            statusCode: res.response.status,
            message: res.response.data
          })
        }
      })
  },
  data() {
    return {
      story: { content: {} }
    }
  },
  components: {
    StandardHero,
    ProductIntro,
    ProductSellingPoints,
    Benefits,
    ProductRelatedApps,
    /* RelatedCasesSlider, */
    Partnership,
    ContactUs
  },
  mounted() {
    // use the bridge to listen to events
    this.$storybridge.on(['input', 'published', 'change'], (event) => {
      if (event.action == 'input') {
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content
        }
      } else {
        // window.location.reload()
        this.$nuxt.$router.go({
          path: this.$nuxt.$router.currentRoute,
          force: true
        })
      }
    })
  },
  computed: {
    // header() {
    //   let header = this.headertmp
    //   if (header[0].background) {
    //     header[0].image = header[0].background
    //   }
    //   return header
    // },
    pageVar() {
      let pageVar = {
        name:
          this.header !== undefined &&
          this.header[0] !== undefined &&
          this.header[0].textline !== undefined &&
          this.header[0].textline[0] !== undefined &&
          this.header[0].textline[0].text !== undefined
            ? this.header[0].textline[0].text
            : null,
        primaryColor:
          this.primaryColor &&
          this.primaryColor[0] !== undefined &&
          this.primaryColor[0].color !== undefined
            ? this.primaryColor[0].color
            : '#F9AB00',
        secondaryColor:
          this.secondaryColor &&
          this.secondaryColor[0] !== undefined &&
          this.secondaryColor[0].color !== undefined
            ? this.secondaryColor[0].color
            : '#E37400',
        wavesColor:
          this.wavesColor &&
          this.wavesColor[0] !== undefined &&
          this.wavesColor[0].color !== undefined
            ? this.secondaryColor[0].color
            : '#EEEEEE'
      }
      return pageVar
    }
  }
}
